module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/Prizes/cash_money-9badb2d80b0721e5d927872ab16b7967.svg";